import { makeAutoObservable, runInAction } from 'mobx';

import { client } from 'contexts/ApolloClient/apolloClient';
import { standardError } from 'global/commonMessages';
import { notificationStore } from 'global/NotificationStore';
import { DELETE_MEMBER_FROM_GROUP } from 'pages/Profile/gql/deleteMemberFromGroup';
import { GET_GROUP_MEMBERS } from 'pages/Profile/gql/getGroupMembers';
import { groupsStore } from 'pages/Profile/GroupsStore';

class SingleGroupStore {
	members = [];
	isLoading = false;
	isInDelete = false;
	isDeleteLoad = false;
	selectedForDelete = '';

	constructor() {
		makeAutoObservable(this);
	}

	getCrewMembers = async (groupID) => {
		this.isLoading = true;
		try {
			const response = await client.query({
				query: GET_GROUP_MEMBERS,
				variables: {
					groupID,
				},
				fetchPolicy: 'no-cache',
			});
			runInAction(() => {
				this.members = response.data.crewMemberSearch.results;
				this.isLoading = false;
			});
		} catch (e) {
			this.isLoading = false;
			notificationStore.setNotification(standardError);
		}
	};

	addMembers = (newMembers) => {
		this.members = [...this.members, ...newMembers];
	};

	reset = () => {
		this.members = [];
		this.isLoading = false;
		groupsStore.endSelection();
		groupsStore.fetchGroups();
	};

	triggerDeleteMode = (crewId) => {
		this.selectedForDelete = crewId;
		this.isInDelete = true;
	};

	resetDeleteMode = () => {
		this.selectedForDelete = '';
		this.isInDelete = '';
		this.isDeleteLoad = false;
	};

	deleteMemberFromGroup = async () => {
		this.isDeleteLoad = true;
		const payload = {
			crewMemberId: this.selectedForDelete,
			groupsIds: [groupsStore.selectedGroup.id],
		};

		try {
			const response = await client.mutate({
				mutation: DELETE_MEMBER_FROM_GROUP,
				variables: {
					input: payload,
				},
				fetchPolicy: 'no-cache',
			});
			const index = this.members.findIndex(
				(member) => member.id === response.data.unAssignCrewMemberFromGroups.id
			);
			runInAction(() => {
				this.members.splice(index, 1);
				this.selectedForDelete = '';
				this.isInDelete = '';
				this.isDeleteLoad = false;
			});
		} catch (e) {
			this.isDeleteLoad = false;
			console.error(e);
			notificationStore.setNotification(standardError);
		}
	};
}

export const singleGroupStore = new SingleGroupStore();
